var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_g_94_4671)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.59961,
    y: 1.59961,
    width: 52,
    height: 52,
    rx: 12,
    fill: "#4452E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_g_94_4671",
    x: -0.000390649,
    y: -0.000390649,
    width: 55.2,
    height: 55.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.071942448616027832 0.071942448616027832",
    numOctaves: 3,
    seed: 7951
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 3.200000047683716,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_94_4671"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge1);
export default __webpack_public_path__ + "static/media/badge-1.aa34894684e07fe3e4dc1367b7d834b0.svg";
export { ForwardRef as ReactComponent };